
export const addCustomer = () => {
    return async (dispatch) => {
        const customer = {
            ShowStar:false,
            isMobile0:false,
            isMobile:false,
            isTablet:false,
            isTablet2:false,
            Presenter:'',

            serviceType:1,
            serviceCode:0,
            serviceWithModem:false,
            equipmentCode:0,
            checkPhone:-1,

            Real:1,
            Email:'',
            CompanyName:'',
            VerifyCode:'',
            PayWay:1,
            DiscountCode:'',
            CustomerCode:0,
            FactorCode:0,
            UserName:'',
            Password:'',
            BankName:'',
            BankLogo:'',

            FillInfo:0,
            Name:'',
            Family:'',
            Melli:'',
            Mobile:'',
            Phone:'',
            PrePhone:'021',
            PhonePure:'',
            ZipCode:'',
            Address:'',
            Year:'0',
            Month:'0',
            Day:'0',
            Sex:'1',
            City:'0',
            Region:'0',
            Know:'0',
            SecurityCodeDone:0,
            MobileVerified:0,
            Bank:0,
            ServiceHasEquipment:0,

            // serviceType:1,
            // serviceCode:110,
            // CustomerCode:1925710,
            // FactorCode:638322,

            // FillInfo:1,
            // Name:'تست',
            // Family:'تستی',
            // Melli:'2396132654',
            // Mobile:'9173287970',
            // Phone:'7191015159',
            // ZipCode:'2369856321',
            // Address:'شیراز',
            // Year:'1399',
            // Month:'1',
            // Day:'1',
            // Sex:'1',
            // // City:'1',
            // Region:'1',
            // Know:'1',
            // SecurityCodeDone:1,
            // MobileVerified:1,
            // Bank:17,

            
        };

        await dispatch({type:"ADD",payload:customer});
    };
};

export const updateCustomer = (data) => {
    //console.log("StoreLog: UpdateCustomer => ",{data});
    return async (dispatch,getState) => {
        const customer=getState().customer;
        await dispatch({type:"UPDATE",payload:{ ...customer, ...data}});
    };
};

export const clearCustomer = () => {
    console.log("StoreLog: ClearCustomer");
    return async (dispatch,getState) => {
        const customer=getState().customer;
        customer={};

        await dispatch({type:"CLEAR",payload:customer});
    };
};

